import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Components/LoginComp/login";
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute";
import Body from "./Components/BodyComp/body";
import ForgotPassword from "./Components/LoginComp/forgotpassword";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} /> {/* Login route */}
        <Route path="/login" element={<Login />} /> {/* Add this line */}
        <Route path="/forgotpassword" element={<ForgotPassword />} /> {/* Add this line */}
        {/* Private route for /body */}
        <Route
          path="/body"
          element={
            <PrivateRoute>
              <Body />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
